"use strict";
/*
 * Created on 19. 5. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var DistributionException_1 = require("../model/DistributionException");

var DistributionExceptionConverter_1 = require("./DistributionExceptionConverter");
/**
 * Default implementation of DistributionExceptionConverter.
 *
 * @author Radek Beran
 */


var DistributionExceptionConverterImpl =
/*#__PURE__*/
function (_DistributionExceptio) {
  _inherits(DistributionExceptionConverterImpl, _DistributionExceptio);

  function DistributionExceptionConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, DistributionExceptionConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DistributionExceptionConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DistributionExceptionConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new DistributionException_1.DistributionException(DistributionException_1.DistributionException.schema.id.valueOf(conversions.documentToClassId(source)), DistributionException_1.DistributionException.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), DistributionException_1.DistributionException.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), DistributionException_1.DistributionException.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), DistributionException_1.DistributionException.schema.groupOfSitesId.valueOf(conversions.toClassReferenceId(source.groupOfSitesId)), conversions.asObjectList(source, 'siteIds', function (id) {
        return conversions.toClassReferenceId(id);
      }), conversions.asObjectList(source, 'siteExternalIds', function (externalId) {
        return externalId;
      }), utils_1.Utils.isValueMissing(source.distrModelId) ? null : DistributionException_1.DistributionException.schema.distrModelId.valueOf(conversions.toClassReferenceId(source.distrModelId)), DistributionException_1.DistributionException.schema.distrModelDays.valueOfField(source), DistributionException_1.DistributionException.schema.lockType.valueOfField(source), DistributionException_1.DistributionException.schema.justInTime.valueOf(source.justInTime ? source.justInTime : false), DistributionException_1.DistributionException.schema.lastChangeTime.valueOfField(source), DistributionException_1.DistributionException.schema.lastChangeUser.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        productId: conversions.toDocumentReferenceId(source.productId),
        groupOfSitesId: conversions.toDocumentReferenceId(source.groupOfSitesId),
        siteIds: conversions.asObjectArray(source, 'siteIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        siteExternalIds: conversions.asObjectArray(source, 'siteExternalIds', function (id) {
          return id;
        }),
        distrModelId: conversions.toDocumentReferenceId(source.distrModelId),
        distrModelDays: source.distrModelDays,
        lockType: source.lockType,
        justInTime: source.justInTime,
        lastChangeTime: utils_1.Utils.isValueMissing(source.lastChangeTime) ? null : conversions.fromDate(source.lastChangeTime),
        lastChangeUser: utils_1.Utils.isValueMissing(source.lastChangeUser) ? null : this.userInfoConverter.toDocument(source.lastChangeUser, conversions)
      });
      return result;
    }
  }]);

  return DistributionExceptionConverterImpl;
}(DistributionExceptionConverter_1.DistributionExceptionConverter);

DistributionExceptionConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], DistributionExceptionConverterImpl);
exports.DistributionExceptionConverterImpl = DistributionExceptionConverterImpl;